export default __webpack_public_path__ + "static/media/1955.766671fd.png";